import { CheckIcon } from "lucide-react";
import React from "react";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
  className?: string; // Optional className prop for additional styling
}

function Checkbox(props: CheckboxProps) {
  const { label, checked, onCheck, className, ...rest } = props;

  return (
    <label
      className={`flex items-center gap-4 cursor-pointer ${className}`}      
    >
      <input
        {...rest}
        type="checkbox"
        checked={checked}
        className="peer sr-only"
        onChange={(e) => onCheck(e.target.checked)}
        aria-label={checked ? `${label} checked` : `${label}`}  
      />
      <div className="peer-checked:block hidden mt-1 bg-[#FFBE74] w-[20px] h-[20px] rounded-[4px]">
        {/* checked */}
        <CheckIcon size={18} className="ml-[1px] mt-[2px] text-primary-900" />        
      </div>
      <div className="peer-checked:hidden block mt-1 bg-primary-50 dark:bg-[#313A71] w-[20px] h-[20px] rounded-[4px] border border-[#CBC9F2] dark:border-[#CBC9F2]"></div>
      <span className="text-primary-900 dark:text-primary-200 paragraph-small-medium" aria-hidden="true">
        {label}
      </span>
    </label>
  );
}

export default Checkbox;
